import React from 'react';
import comingSoonImg from '../../assets/images/coming-soon.webp';
import mobileComingSoonImg from '../../assets/images/mobile-coming-soon.webp';
const ComingSoonSection = () => {
  return (
    <div className="coming-soon-container">
      {/* Heading */}
      <h2 className="coming-soon-title">
        And Much more... Coming soon.
      </h2>

      {/* Image Below the Heading */}
      <div className="coming-soon-image-container">
        <picture>
          <source media="(max-width: 767px)" srcSet={mobileComingSoonImg} />
          <img
            src={comingSoonImg}
            alt="MyNaksh Coming Soon Preview"
            className="coming-soon-image"
          />
        </picture>
      </div>
    </div>
  );
};

export default ComingSoonSection;
